@if (isFieldInvalidAndDirtyAndTouched()) {
  @if (isFieldErrorsRequired()) {
    <span class="form-text small text-danger">
      {{ label }} é um campo obrigatório.
    </span>
  }

  @if (isFieldErrorsMin()) {
    <span class="form-text small text-danger">
      {{ label }} está com poucos caracteres.
    </span>
  }

  @if (isFieldErrorsMax()) {
    <span class="form-text small text-danger">
      {{ label }} está com o número de caracteres excedido.
    </span>
  }

  @if (isFieldErrorsPattern()) {
    <span class="form-text small text-danger">
      {{ label }} está com o padrão inválido.
    </span>
  }

  @if (isFieldErrorsPreviousDate()) {
    <span class="form-text small text-danger">
      {{ label }} retroativa não é permitida.
    </span>
  }

  @if (isFieldErrorsFutureDate()) {
    <span class="form-text small text-danger">
      {{ label }} futura não é permitida.
    </span>
  }

  @if (isFieldErrors18YearOldDate()) {
    <span class="form-text small text-danger">
      {{ label }} é uma data que não atinge a maioridade.
    </span>
  }

  @if (isFieldErrorsEmail()) {
    <span class="form-text small text-danger">{{ label }} está inválido.</span>
  }

  @if (isFieldErrorsCpf()) {
    <span class="form-text small text-danger">{{ label }} está inválido.</span>
  }

  @if (isFieldErrorsCnpj()) {
    <span class="form-text small text-danger">{{ label }} está inválido.</span>
  }

  @if (isFieldErrorsRequest()) {
    <span class="form-text small text-danger">
      {{ label }} está no formato errado.
    </span>
  }

  @if (isFieldErrorsMustMatch()) {
    <span class="form-text small text-danger">{{ label }} não confere com a nova senha.</span>
  }

  @if (isMatDatepickerParse()) {
    <span class="form-text small text-danger">
      {{ label }} está no formato inválido (DD/MM/YYYY).
    </span>
  }
  
}
